export const DEMO1_EXCHANGER = {
  firstName: 'Matt',
  lastName: 'Belcher',
  email: 'exchanger@open1031.demo',
  phone: '3105551234',
  addressCity: 'Beverly Hills',
  addressState: 'CA',
  addressStreet: '1031 Exchange Lane',
  addressZip: '90210',
  ssnLastFour: '6789',
  tinType: 'ssn' as const,
};

export const DEMO1_LEGAL_ENTITY = 'Matt Belcher';

export const DEMO1_SALES_PRICE = 1000000;

export const DEMO1_ADJUSTED_BASIS = 400000;

export const DEMO1_REPLACEMENT_COST = 1000000;

export const DEMO1_RELINQUISHED = {
  street: '12301 Mockingbird Lane',
  city: 'Los Angeles',
  state: 'CA',
  zip: '90049',
  addressOrLegalDescription: '12301 Mockingbird Lane, Los Angeles, CA 90049',
};

export const DEMO1_REPLACEMENT = {
  street: '2026 Sample Plaza',
  city: 'Beverly Hills',
  state: 'CA',
  zip: '90210',
  addressOrLegalDescription: '2026 Sample Plaza, Beverly Hills, CA 90210 — Delaware Statutory Trust (DST) Interest',
};

export const DEMO1_BUYER = {
  names: 'Pacific Coast Properties LLC',
  acknowledgmentSigner: 'James R. Whitfield, Managing Member',
};

export const DEMO1_SELLER = {
  names: 'Roxbury DST Manager LLC',
  acknowledgmentSigner: 'Thomas C. Hargrove, Managing Director',
};

export const DEMO1_CLOSING_COMPANY_SALE = {
  name: 'Great Title 1031 — Los Angeles',
  address: '1031 Demo Boulevard, Suite 200, Los Angeles, CA 90064',
  phone: '3105550143',
  email: 'closings@greattitle1031.example.com',
  closerName: 'Sarah Johnson',
  closerEmail: 'sarah.johnson@greattitle1031.example.com',
};

export const DEMO1_CLOSING_COMPANY_PURCHASE = {
  name: 'Pacific Title & Escrow — Beverly Hills',
  address: '3300 Demo Avenue, Suite 800, Beverly Hills, CA 90210',
  phone: '3105550155',
  email: 'closings@pacifictitle1031.example.com',
  closerName: 'Michael Torres',
  closerEmail: 'michael.torres@pacifictitle1031.example.com',
};

export const DEMO1_DISBURSEMENT = {
  wireRecipient: 'Pacific Title & Escrow — Beverly Hills',
  wireRecipientAddress: '3300 Demo Avenue, Suite 800, Beverly Hills, CA 90210',
  wireRecipientBankName: 'Frost Bank',
  wireRecipientBankABA: '123456789',
  wireRecipientBankAccount: '****7842',
  beneficiaryName: 'Roxbury DST Manager LLC — Exchange Proceeds Account',
};

export const DEMO1_ESCROW_FILE_NUMBER = 'WTA-2026-103178';

export const DEMO1_QI_WIRE = {
  bankName: 'Western Alliance Bank',
  bankAddress: 'One E Washington St, Phoenix AZ 85004',
  abaRouting: '122 105 2453',
  accountNumber: '8456 2901 7842',
  swiftBic: 'WALAUS6P',
  beneficiaryName: 'Open 1031, Inc. — QI Custodial Trust Account',
  beneficiaryAddress: '1 N Central Ave, Phoenix AZ 85004',
};

export const DEMO1_COUNTER_SIGNATURES = {
  qiOfficerName: 'Tom Bottenberg',
  qiOfficerTitle: 'Chief Operations Officer',
  purchaserSignerName: 'James R. Whitfield',
  purchaserSignerTitle: 'Managing Member',
  purchaserSignerDaysBeforeExchanger: 3,
};

export const DEMO1_IDENTIFICATION_PROPERTIES = [
  {
    address: 'Inland Diversified Net-Lease Retail DST — 4-property portfolio (TX, AZ, NV, CO)',
    type: 'dst' as const,
    estimatedFMV: 700000,
    allocationAmount: 700000,
    investmentAmount: 700000,
    totalOfferingSize: 50000000,
    dstTitle: 'Inland Diversified Net-Lease Retail DST',
    properties: [
      { address: '1031 Demo Plaza, Austin, TX 78701' },
      { address: '2026 Sample Center, Phoenix, AZ 85016' },
      { address: '3300 Demo Avenue, Las Vegas, NV 89109' },
      { address: '4400 Sample Drive, Denver, CO 80202' },
    ],
  },
  {
    address: '5500 Mockingbird Heights, Beverly Hills, CA 90210 — DST Interest',
    type: 'dst' as const,
    estimatedFMV: 200000,
    allocationAmount: 200000,
    investmentAmount: 200000,
    totalOfferingSize: 25000000,
    dstTitle: 'NW Loop Commercial DST',
    properties: [
      { address: '5500 Mockingbird Heights, Beverly Hills, CA 90210' },
    ],
  },
  {
    address: '6600 Sample Industrial Way, Houston, TX 77041 — DST Interest',
    type: 'dst' as const,
    estimatedFMV: 100000,
    allocationAmount: 100000,
    investmentAmount: 100000,
    totalOfferingSize: 30000000,
    dstTitle: 'Houston Industrial DST',
    properties: [
      { address: '6600 Sample Industrial Way, Houston, TX 77041' },
    ],
  },
];

export const DEMO1_DEADLINES_OFFSET = {
  saleCloseDaysAgo: 2,
  identificationDeadlineDays: 43,
  exchangeDeadlineDays: 178,
};

export function daysFromNow(days: number): string {
  return new Date(Date.now() + days * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function buildDemo1ExchangeRow(orgId: string): {
  account_id: string;
  owning_org_id: string;
  name: string;
  status: string;
  exchange_type: string;
  sale_close_date: string | null;
  identification_deadline: string | null;
  exchange_deadline: string | null;
  relinquished_value: number;
  is_demo: boolean;
} {
  return {
    account_id: orgId,
    owning_org_id: orgId,
    name: `${DEMO1_LEGAL_ENTITY} — 1031 Exchange`,
    status: 'active',
    exchange_type: 'delayed',
    sale_close_date: null,
    identification_deadline: null,
    exchange_deadline: null,
    relinquished_value: DEMO1_SALES_PRICE,
    is_demo: true,
  };
}

export function buildDemo1ExtractedDates(): {
  saleCloseDate: string;
  identificationDeadline: string;
  exchangeDeadline: string;
} {
  return {
    saleCloseDate: daysFromNow(-DEMO1_DEADLINES_OFFSET.saleCloseDaysAgo),
    identificationDeadline: daysFromNow(DEMO1_DEADLINES_OFFSET.identificationDeadlineDays),
    exchangeDeadline: daysFromNow(DEMO1_DEADLINES_OFFSET.exchangeDeadlineDays),
  };
}
